export default {
  button_add_bookmark: 'Add bookmark',
  button_add_highlight: 'Add highlight',
  button_cancel: 'Cancel ',
  button_close_app: 'Close ',
  button_close: 'Close',
  button_full_screen: 'Fullscreen',
  button_full_screen_exit: 'Exit fullscreen',
  button_log_in_again: 'Log in again',
  button_reset: 'Reset',
  button_save: 'Save',
  button_settings: 'Settings',
  button_volume: 'Sound on (M)',
  button_volume_muted: 'Sound off (M)',
  button_web_reverse: 'Back (Alt + left arrow)',
  button_web_play: 'Play (Ctrl/Cmd + shift + P)',
  button_web_pause: '',
  button_web_forward: 'Forward (Alt + right arrow)',
  button_table_of_contents: 'Table of contents (Ctrl/Cmd + I)',
  label_autoplay_on: 'Automatic page turn enabled ',
  label_autoplay_off: 'Automatic page turn disabled ',
  label_new_bookmark: 'New bookmark',
  label_edit_bookmark: 'Edit bookmark',
  label_open_reader_controls: 'Open reader controls',
  label_teacher_highlight: 'Teacher highlight',
  label_new_highlight: 'New highlight',
  label_edit_highlight: 'Edit highlight',
  label_highlight: 'Highlight',
  label_underline: 'Underline',
  label_add_note: 'Add note',
  label_edit_note: 'Edit note',
  label_color: 'Color',
  label_annotation_type: 'Annotation type',
  text_action_highlight: 'Highlight',
  text_action_underline: 'Underline',
  text_action_play: 'Play from here',
  text_action_cancel: 'Cancel',
  text_action_menu_title: 'Choose action',
  label_playback_rate: 'Reading speed',
  label_playback_rate_changing: 'Change reading speed',
  label_sentence_highlighting_on: 'Text highlighting on ',
  label_sentence_highlighting_off: 'Text highlighting off',
  label_settings: 'Settings',
  label_volume_slider: 'Change volume',
  label_decrease_volume: 'Decrease volume',
  label_increase_volume: 'Increase volume',
  label_lock_screen: 'Lock screen',
  label_font_size: 'Font size',
  label_use_font_one: 'Use font one',
  label_use_font_two: 'Use font two',
  message_under_development:
    'The browser version is still under development and some features are not yet available. We are working on it.',
  placeholder_bookmark_notes: 'Make a note here.',
  submissions: {
    button_form_title: 'Submission form',
  },
  title_table_of_contents: 'Table of contents',
  title_annotations: 'Annotations',
  title_bookmarks: 'Bookmarks',
  title_highlights: 'Highlights',
  button_highlights: 'Highlights',
  no_media_playback: 'The book has no audio',
  error_fault_in_book_message:
    'Unfortunately, there was an error opening this book. The book will be closed. Please contact customer service if the problem persists.',
  error_no_access: 'You do not have permission to view the book. Please log in again and try again.',
  error_not_found: 'The book cannot be displayed. Please open the book again.',
  error_in_book_unknown:
    'Unknown error, Please try again later. Should the error persist, please contact customer service.',
  skip_by: 'Skip by',
  skip_by_default: 'Default',
  skip_by_heading: 'Heading level {level}',
  skip_by_pages: 'Pages',
  skip_by_15_seconds: '15 seconds',
  skip_by_30_seconds: '30 seconds',
  bookmark_form_name: 'Name',
  bookmark_form_comment: 'Comment (optional)',
  bookmark_form_rule: 'You must enter a name.',
  bookmark_created_message: 'Bookmark created',
  highlight_form_comment: 'Comment',
  highlight_form_comment_optional: 'Comment (optional)',
  button_delete: 'Delete',
  button_edit: 'Edit',
  book_player: {
    button_playlist: 'Playlist',
    message_no_toc_items: 'No items available',
    message_no_navigation: 'This book has no table of contents',
    message_navigation_failed: 'The table of contents could not be loaded',
    message_position_temporal_offset: 'The link starts partway into the audio. Choosing another position removes that.',
    label_position_pages: 'Page {pages}',
    label_position_tree: 'Start position',
    message_position_selected: 'Selected: {label}',
    message_position_end: 'End: {label}',
    message_position_removed: 'Removed: {label}',
    message_position_cleared: 'No start position selected',
    label_position_no_end: 'No end point',
    label_position_no_end_hint: 'To the end of the book',
    message_no_playlist_items: 'No playlist items available',
    label_playlist: 'Playlist',
    label_pages: 'Pages',
    label_bookmarks: 'Bookmarks',
    label_table_of_contents: 'Table of contents',
    label_annotations: 'Annotations',
    label_duration_seconds_short: 'sec',
    label_duration_minutes_short: 'min',
    label_duration_hours_short: 'h',
    label_page: 'Page',
    label_navigation_levels: 'Navigation levels',
    label_no_navigation_levels: 'No navigation levels',
    label_select_navigation_level: 'Select navigation level',
    label_skip_back_5_seconds: 'Rewind 5 seconds',
    label_skip_back_10_seconds: 'Rewind 10 seconds',
    label_skip_back_15_seconds: 'Rewind 15 seconds',
    label_skip_back_30_seconds: 'Rewind 30 seconds',
    label_skip_back_45_seconds: 'Rewind 45 seconds',
    label_skip_back_page: 'Skip back one page',
    label_skip_backwards_by_heading: 'Skip backwards to heading level {level}',
    label_skip_forward_5_seconds: 'Fast forward 5 seconds',
    label_skip_forward_10_seconds: 'Fast forward 10 seconds',
    label_skip_forward_15_seconds: 'Fast forward 15 seconds',
    label_skip_forward_30_seconds: 'Fast forward 30 seconds',
    label_skip_forward_45_seconds: 'Fast forward 45 seconds',
    label_skip_forward_by_heading: 'Skip forward to heading level {level}',
    label_skip_forward_page: 'Skip forward one page',
    message_skip_by_15_seconds: 'Skip by 15 seconds',
    message_skip_by_30_seconds: 'Skip by 30 seconds',
    message_skip_by_default: 'Skip by default',
    message_skip_by_heading: 'Skip by heading level {level}',
    message_skip_by_page: 'Skip by page',
    label_current_font_size: 'Font size percent',
    button_decrease_font_size: 'Decrease font size percent',
    button_increase_font_size: 'Increase font size percent',
    label_font_choice: 'Font style selection',
    label_current_narration_speed: 'Playback speed',
    button_decrease_playback_rate: 'Decrease playback speed',
    button_increase_playback_rate: 'Increase playback speed',
    label_text_font: 'Text font',
    label_interactive_screen_lock_overlay: 'Interactive screen lock overlay',
    message_play_pause_no_media_playback: 'Cant play, has no media playback',
    message_start_playback: 'Start media playback',
    message_pause_playback: 'Pause media playback',
    label_language_is_selected: '{language} is selected',
    label_bookmark_page_nr: 'Page {pageNr}',
    button_add_new_bookmark: 'Add new bookmark',
    button_go_back: 'Go back',
    label_current_reading_position: 'Current reading position',
    label_percentage_read: '{percentage}% read',
    label_from_to_of_total: '{from} to {to} of {total}',
    label_page_to_of_total: 'Page {to} of {total}',
    label_pages_from_to_of_total: 'Pages {from} to {to} of {total}',
    label_segment_to_of_total: 'Segment {to} of {total}',
    label_segment: 'Segment {n}',
    button_skip_to_content: 'Skip to content',
    button_start_over: 'Start over',
    button_return_to_narration: 'Return to narration',
    label_page_thumbnails: 'Page thumbnails',
    label_reading_mode: 'Reading mode',
    label_audio_mode: 'Audio mode',
    label_audio_progress_slider: 'Audio progress',
    button_continue: 'Continue',
    button_go_to_playback: 'Return to playback',
    button_continue_browsing: 'Continue browsing',
    label_continue_reading: 'Continue reading',
    label_auto_follow_playback: 'Auto-follow playback',
    label_switch_to_track_seeking: 'Switch to track seeking',
    label_switch_to_time_seeking: 'Switch to time seeking',
    label_track_seeking: 'Track seeking',
    label_time_seeking: 'Time seeking',
    label_audio_total: 'Total',
    label_skipped_backward: 'Skipped backward {n}',
    label_skipped_forward: 'Skipped forward {n}',
    label_speed_increased: 'Increased speed to {speed}x',
    label_audio_track: 'Track',
    label_audio_playlist: 'Playlist',
    label_remaining_of_book: 'Remaining of the book',
    button_fullscreen: 'Fullscreen',
    button_fullscreen_exit: 'Exit fullscreen',
    label_audio_only_beta_tooltip: 'Beta - Work in Progress',
    label_highlight_toolbar_title: 'Highlight toolbar',
    label_annotation_type: 'Annotation type',
    label_annotation_highlight: 'Highlight',
    label_annotation_underline: 'Underline',
    label_annotation_add_comment: 'Add comment',
    label_annotation_edit_comment: 'Edit comment',
    label_annotation_add_note: 'Add note',
    label_annotation_edit_note: 'Edit note',
    label_annotation_color_yellow: 'Yellow',
    label_annotation_color_green: 'Green',
    label_annotation_color_pink: 'Pink',
    label_annotation_color_cyan: 'Cyan',
    label_annotation_color_magenta: 'Magenta',
    label_annotation_saving: 'Saving…',
    label_annotation_deleting: 'Deleting…',
    label_audio_highlight_color_yellow: 'Default Yellow',
    label_audio_highlight_color_red: 'Rose',
    label_audio_highlight_color_blue: 'Cerulean',
    label_audio_highlight_color_green: 'Aqua',
    label_audio_highlight_color_dark_yellow: 'Default Amber',
    label_audio_highlight_color_dark_red: 'Berry',
    label_audio_highlight_color_dark_blue: 'Cobalt',
    label_audio_highlight_color_dark_green: 'Deep Teal',
    label_play_from_sentence: 'Play from here',
    label_annotation_save_as: 'Save as',
    label_close: 'Close',
    message_highlight_created: 'Highlight created',
    message_no_highlights_found: 'No highlights found',
  },
} as const;
